export default __webpack_public_path__ + "static/media/element_10.90731450.webp";